/**
 * Created by LCGC-04406-257-PC on 2017/5/9.
 */

$(function(){
    var cd_gpsm  = "cd_gpsm";

    var Cd_gpsm = function(element,opt){
        this.elem = $(element);
        this.deleteBtn = $(element).find(opt.closeBtnClass);
        this.option = opt;
    };

    Cd_gpsm.DEFAULTS = {
        closeBtnClass:'.delete',
        beforeRemoved: function($this){
            console.log($this);
        },
        whenClickRemoved: function($this){
            console.log($this);
        }
    };

    Cd_gpsm.prototype.deleteDOM = function(){
        this.elem.remove();
    };
    $.fn[cd_gpsm] = function(options,options2){
        return this.each(function(){
            var $this = $(this);
            var module = $this.data( cd_gpsm );
            var opts = null;
            if ( !!module ) {
                if ( typeof options === 'string' &&  typeof options2 === 'undefined' ) {
                    module[options]();
                } else {
                    throw 'unsupported options!';
                }
            } else {
                opts = $.extend( {}, Cd_gpsm.DEFAULTS , ( typeof options === 'object' && options ) , ( typeof options2 === 'object' && options2 ));
                module = new Cd_gpsm(this,opts);
                $this.data( cd_gpsm, module );

                // �]���¼�
                module.deleteBtn.on('click', function() {
                    (!!module.option.beforeRemoved && typeof module.option.beforeRemoved === 'function') && module.option.beforeRemoved($this);
                    module.deleteDOM();
                    if(typeof module.option.whenClickRemoved === 'function'){
                        module.option.whenClickRemoved($this);
                    }
                });
            }
        });
    }
});